import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Home, Crosshair, BarChart3, User, LayoutDashboard, Video, MessageSquare, BookOpen } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { messagesAPI } from '../lib/api';

const playerNav = [
  { to: '/dashboard', icon: Home, label: 'Home' },
  { to: '/progress', icon: Crosshair, label: 'Train' },
  { to: '/community', icon: BarChart3, label: 'Community' },
  { to: '/library', icon: BookOpen, label: 'Library' },
  { to: '/profile', icon: User, label: 'Profile' },
];

const coachNav = [
  { to: '/coach', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/coach/drills', icon: Crosshair, label: 'Drills' },
  { to: '/coach/plans', icon: BarChart3, label: 'Plans' },
  { to: '/coach/messages', icon: MessageSquare, label: 'Messages' },
  { to: '/coach/feedback', icon: Video, label: 'Reviews' },
];

export default function BottomNav() {
  const { user, isAuthenticated } = useAuth();
  const location = useLocation();
  const items = user?.role === 'coach' ? coachNav : playerNav;
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (!isAuthenticated) return;
    const poll = async () => {
      try {
        const res = await messagesAPI.unreadCount();
        setUnread(res.data?.unread || 0);
      } catch {}
    };
    poll();
    const interval = setInterval(poll, 10000);
    return () => clearInterval(interval);
  }, [isAuthenticated]);

  // Hide on landing, login, register, onboarding
  const hidePaths = ['/', '/login', '/register', '/onboarding', '/plan-ready'];
  if (hidePaths.includes(location.pathname)) return null;
  // Also hide on message thread pages and public profile pages
  if (location.pathname.match(/^\/(messages|coach\/messages)\/[^/]+$/)) return null;
  if (location.pathname.match(/^\/profile\/[^/]+$/)) return null;

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-[#0A2242] border-t border-[#0A2242] bottom-nav" data-testid="bottom-nav">
      <div className="flex items-center justify-around max-w-lg mx-auto px-1 py-1.5 sm:px-2 sm:py-2">
        {items.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={`nav-${label.toLowerCase()}`}
            className={({ isActive }) =>
              `flex flex-col items-center gap-0.5 px-2 py-1.5 rounded-xl transition-all relative ${
                isActive
                  ? 'text-[#00BFFF]'
                  : 'text-[#7B93B8] hover:text-white'
              }`
            }
          >
            <Icon size={20} strokeWidth={2.5} />
            {label === 'Messages' && unread > 0 && (
              <span className="absolute -top-0.5 right-0.5 bg-[#EF4444] text-white text-[7px] font-bold w-3.5 h-3.5 rounded-full flex items-center justify-center" data-testid="unread-badge">
                {unread > 9 ? '9+' : unread}
              </span>
            )}
            <span className="text-[9px] sm:text-[10px] font-bold uppercase tracking-wider">{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
